import React from 'react'
import ClassName from 'classnames'
import ObjectToQueryString from 'lib/objectToQueryString'
import styles from './StreetView.module.scss'

const StreetView = ({
  apiKey,
  className = '',
  title = 'streetView',
  parameters,
}) => {
  if (!parameters) return null

  const queryString = ObjectToQueryString(parameters)
  const url = `https://www.google.com/maps/embed/v1/streetview?key=${apiKey}&${queryString}`

  return (
    <iframe
      title={title}
      src={url}
      className={ClassName(styles.streetView, className)}
    />
  )
}

export default React.memo(StreetView)
